import 'Styles/commonComponents/namedBlock.scss';
import React from 'react';

const NamedBlock = (props) => {
    return (
        <div id={props.id}
             key={props.key}
             className={`named-block ${props.className == null ? '' : props.className}`}>
            <div className='named-block-content'>
                <div className='named-block-title text-overflow-dotted' style={{ maxWidth: "90%", maxHeight: "40px" }}>
                    {props.title}
                </div>
                {props.children}
            </div>
        </div>
    )
}

export default NamedBlock;